import { useQuery } from '@tanstack/react-query';

import { getHttpClient, useHttpClient } from '@bonusly/http-client';

import { getQueryClient } from '../lib/query-client';

enum QueryKey {
	Countries = 'form-data:countries',
}

const countriesQueryKey = () => [QueryKey.Countries];

type CountriesAPIData = {
	data: {
		id: string;
		isoAlpha2Code: string;
		name: string;
	}[];
};

export const loadCountryOptions = async () => {
	const http = await getHttpClient('rcs');
	const queryClient = await getQueryClient();

	return queryClient.fetchQuery(countriesQueryKey(), async () => {
		const response = await http.get<CountriesAPIData>('/countries');
		return response.data.data;
	});
};

export const useCountryOptions = () => {
	const http = useHttpClient('rcs');

	return useQuery({
		queryKey: countriesQueryKey(),
		queryFn: async () => {
			const response = await http.get<CountriesAPIData>('/countries');
			return response.data.data;
		},
	});
};
